import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import SecretariaService from '../../services/secretaria'
import Secretaria from './secretaria';
import '../../styles/lrf.scss';

const ListarSecretarias = () => {

    const [secretarias, setSecretarias] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchSecretarias() {
        const response = await SecretariaService.listar();
        if (response.data.length >= 1) {
            setSecretarias(response.data)
            setVazio(false)
        } else {
            setSecretarias([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchSecretarias();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setSecretarias={setSecretarias}
                    setVazio={setVazio}
                    fetchSecretarias={fetchSecretarias}
                    secretarias={secretarias}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <h2 className='titulo-listas'>Secretarias Municipais</h2>
                    <Row xs={1}>
                        {secretarias.map((sec, index) =>
                            <Secretaria
                                sec={sec}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarSecretarias;